var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5385 14.8789C9.48815 14.8789 6.86425 16.2053 5.7001 18.3837C4.99206 19.7086 6.27621 20.999 7.77844 20.999H17.2986C18.8009 20.999 20.085 19.7086 19.377 18.3837C18.2128 16.2053 15.5889 14.8789 12.5385 14.8789Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9428 7.40005C15.9428 9.27785 14.4205 10.8001 12.5428 10.8001C10.665 10.8001 9.1427 9.27785 9.1427 7.40005C9.1427 5.52226 10.665 4 12.5428 4C14.4205 4 15.9428 5.52226 15.9428 7.40005Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.425ff4365250af1e9a737fe53525f305.svg";
export { ForwardRef as ReactComponent };